import React from "react";
import MarksheetTypeSectoin from "../../Sections/MarksheetTypeSection/Content";
const MarksheetType = () => {
  return <MarksheetTypeSectoin />;
};

export default MarksheetType;
